import SummaryStep from './SummaryStep';
import TechnicalDetails from './TechnicalDetails';
import GeneralDetailsStep from './GeneralDetailsStep';
import DivContainerBody from '../../../../../components/DivContainerBody';
import StepperTabs from '../../../../../components/StepperTabs/StepperTabs';
import StepTab from '../../../../../components/StepperTabs/StepTab';
import { ButtonNextStep, ButtonPrevStep } from '../../../../../components/buttons/ButtonNavigation';
import CustomPhotoPicker from '../../../../../components/PhotoPicker/CustomPhotoPicker';
import { FILE_TYPE } from '../../../../../Helpers/fileType';
import { ACTION_MODEL } from '../../../../../Helpers/ActionModel';
import HeadTittle from '../../../../../components/HeadTittle';
import { SUGGESTION_MODE_OPTION } from '../../../../../components/PhotoPicker/SubComponent/Models/Models';
import CreateEquipmentMaterialApp from '../Functionality/CreateEquipmentMaterialApp';
import { STEPS_EQUIPMENT_AND_MATERIAL } from '../Model/Model';
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const CreateEquipmentMaterial = () => {
    const {
        activeStep,
        setActiveStep,
        steps,
        handleStepChange,
        handleCreate,
        t,
        photoPickerFile,
        setPhotoPickerFile,
        disabled,
        item,
        emptyFields,
        handleChange,
        handleOnBack,
        setEmptyFields,
        setIsValid,
        categoryOptions,
        setCategoryOptions,
        subCategoryOptions,
        setSubCategoryOptions,
        selectedCategory,
        setSelectedCategory,
        selectedSubCategory,
        setSelectedSubCategory,
        dispatch,
        handleClearTechnicalDetails,
        handleClearGerneralDetails,
        createSubcategoryBody,
        createCategoryBody,
        handleCreateSubcategoryCategory,
        handleSearchSubcategory,
        handleSearchCategory,
    } = CreateEquipmentMaterialApp();
    return (
        <>
            <HeadTittle onBack={handleOnBack} name={'create'} />

            <DivContainerBody>
                <>
                    <StepperTabs
                        id={null}
                        disabled={false}
                        steps={steps}
                        activeStep={activeStep}
                        isStepOptional={(step) => step == STEPS_EQUIPMENT_AND_MATERIAL.PHOTO.INDEX}
                        setActiveStep={setActiveStep}
                        handleStepChange={handleStepChange}
                    >
                        <StepTab
                            index={STEPS_EQUIPMENT_AND_MATERIAL.GENERAL_DETAILS.INDEX}
                            activeStep={activeStep}
                            normalHeight={true}
                        >
                            <GeneralDetailsStep
                                t={t}
                                item={item}
                                disabled={disabled}
                                emptyFields={emptyFields}
                                handleChange={handleChange}
                                selectedCategory={selectedCategory}
                                setSelectedCategory={setSelectedCategory}
                                selectedSubCategory={selectedSubCategory}
                                setSelectedSubCategory={setSelectedSubCategory}
                                dispatch={dispatch}
                                handleClearFields={handleClearGerneralDetails}
                                createSubcategoryBody={createSubcategoryBody}
                                createCategoryBody={createCategoryBody}
                                handleCreate={handleCreateSubcategoryCategory}
                                handleSearchSubcategory={handleSearchSubcategory}
                                handleSearchCategory={handleSearchCategory}
                                categoryOptions={categoryOptions}
                                setCategoryOptions={setCategoryOptions}
                                subCategoryOptions={subCategoryOptions}
                                setSubCategoryOptions={setSubCategoryOptions}
                            />
                            <div className='col-sm-12 col-xxl-6 col-lg-6 offset-xxl-6 offset-lg-6'>
                                <ButtonNextStep
                                    id='btn_cem_next_general_details'
                                    text='next'
                                    click={() => {
                                        if (!item.isValidGeneralDetails()) {
                                            setEmptyFields(true);
                                            return false;
                                        }
                                        setEmptyFields(false);
                                        setIsValid(true);
                                        setActiveStep((prevStep) => prevStep + 1);
                                    }}
                                />
                            </div>
                        </StepTab>
                        <StepTab
                            index={STEPS_EQUIPMENT_AND_MATERIAL.TECHNICAL_DETAILS.INDEX}
                            activeStep={activeStep}
                            normalHeight={true}
                        >
                            <TechnicalDetails
                                t={t}
                                item={item}
                                disabled={disabled}
                                emptyFields={emptyFields}
                                handleChange={handleChange}
                                handleClearFields={handleClearTechnicalDetails}
                            />
                            <div className='d-flex justify-content-between px-0 mt-3'>
                                <ButtonPrevStep
                                    id='btn_cem_back_file'
                                    text='back'
                                    click={() => setActiveStep((prevStep) => prevStep - 1)}
                                />
                                <ButtonNextStep
                                    id='btn_cem_next_file'
                                    text='next'
                                    disabled={activeStep === steps.length - 1}
                                    click={() => {
                                        if (!item.isValidTechnicalDetails()) {
                                            setEmptyFields(true);
                                            return false;
                                        }

                                        setEmptyFields(false);
                                        setIsValid(true);
                                        setActiveStep((prevStep) => prevStep + 1);
                                    }}
                                />
                            </div>
                        </StepTab>
                        <StepTab
                            index={STEPS_EQUIPMENT_AND_MATERIAL.PHOTO.INDEX}
                            activeStep={activeStep}
                            normalHeight={true}
                        >
                            <CustomPhotoPicker
                                id='fp_cem_create_photo_file'
                                photoPicker={photoPickerFile}
                                setPhotoPicker={setPhotoPickerFile}
                                actionModel={ACTION_MODEL.CREATE}
                                accept={{ ...FILE_TYPE.IMAGE }}
                                showBtnDelete={true}
                                required={false}
                                showBtnCamera={true}
                                validateFace={false}
                                classWith={'content-center-w-400px'}
                                showPreview={true}
                                typeSuggestions={SUGGESTION_MODE_OPTION.MATERIAL_AND_EQUIPMENT}
                                disabled={disabled}
                            />

                            <div className='d-flex justify-content-between px-0 mt-3'>
                                <ButtonPrevStep
                                    id='btn_cem_back_file'
                                    text='back'
                                    click={() => setActiveStep((prevStep) => prevStep - 1)}
                                />
                                <ButtonNextStep
                                    id='btn_cem_next_file'
                                    text='next'
                                    disabled={activeStep === steps.length - 1}
                                    click={() => setActiveStep((prevStep) => prevStep + 1)}
                                />
                            </div>
                        </StepTab>
                        <StepTab
                            index={STEPS_EQUIPMENT_AND_MATERIAL.SUMMARY.INDEX}
                            activeStep={activeStep}
                            normalHeight={true}
                        >
                            <SummaryStep
                                t={t}
                                item={item}
                                selectedSubCategory={selectedSubCategory}
                                selectedCategory={selectedCategory}
                                photoPicker={photoPickerFile}
                            />
                            <div className='d-flex justify-content-between px-0 mb-2'>
                                <ButtonPrevStep
                                    id='btn_cem_back_summary'
                                    text='back'
                                    click={() => setActiveStep((prevStep) => prevStep - 1)}
                                />
                                <ButtonNextStep
                                    id='btn_cem_enroll'
                                    text='create'
                                    click={() => {
                                        handleCreate();
                                    }}
                                />
                            </div>
                        </StepTab>
                    </StepperTabs>
                </>
            </DivContainerBody>
        </>
    );
};

export default CreateEquipmentMaterial;
